<template>
  <div class="coupon-management">
    <el-card class="search-card">
      <div slot="header" class="clearfix">
        <span>优惠券配置</span>
        <el-button style="float: right;" type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增优惠券</el-button>
      </div>

        <el-table :data="tableData" border stripe v-loading="tableLoading" height="calc(100vh - 280px)">
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column prop="name" label="优惠券名称" min-width="150"></el-table-column>
        <el-table-column label="优惠内容" width="150" align="center">
          <template slot-scope="scope">
            满{{ scope.row.threshold || 0 }}元减{{ scope.row.discount }}元
          </template>
        </el-table-column>
        <el-table-column label="有效期" width="220">
          <template slot-scope="scope">
            {{ formatDate(scope.row.startTime) }} ~ {{ formatDate(scope.row.endTime) }}
          </template>
        </el-table-column>
        <el-table-column label="库存/发放" width="170" align="center">
          <template slot-scope="scope">
            <div class="stock-cell" @click="handleShowStats(scope.row)">
              <div class="stock-line">
                剩余 <span class="stock-remain">{{ scope.row.remainStock || 0 }}</span>
                / 总量 {{ scope.row.totalStock || 0 }}
              </div>
              <div class="stock-line stock-issued">
                已发放 {{ getIssuedCount(scope.row) }}
              </div>
              <el-link type="primary" :underline="false" class="stock-link">查看分布</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120"></el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
        <el-table-column label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleStatus(scope.row)">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" size="small" @click="handleRestock(scope.row)" style="color: #E6A23C;">补库存</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-form-item label="优惠券名称" prop="name">
          <el-input v-model="form.name" placeholder="如：新人专享券" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item v-if="!form.id" label="发放对象" prop="issueTargetType">
          <el-select v-model="form.issueTargetType" placeholder="请选择发放对象" style="width: 100%;" @change="handleIssueTargetChange">
            <el-option label="所有人" value="all"></el-option>
            <el-option label="个人" value="individual"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!form.id && form.issueTargetType === 'individual'" label="选择用户" prop="userId">
          <el-select
            v-model="form.userId"
            placeholder="请输入手机号、群昵称或上架代码搜索"
            style="width: 100%;"
            filterable
            remote
            :remote-method="searchUsers"
            :loading="userLoading"
            reserve-keyword
          >
            <el-option
              v-for="u in userOptions"
              :key="u.id"
              :label="formatUserLabel(u)"
              :value="u.id"
            ></el-option>
          </el-select>
          <div class="form-tip">支持按手机号、群昵称、上架代码模糊搜索，创建后将自动发放给该用户</div>
        </el-form-item>
        <el-form-item label="使用门槛" prop="threshold">
          <el-input-number v-model="form.threshold" :min="0" :precision="2" :step="10" placeholder="0表示无门槛"></el-input-number>
          <span class="form-tip" style="margin-left:12px;">元，填0表示无门槛</span>
        </el-form-item>
        <el-form-item label="满减金额" prop="discount">
          <el-input-number v-model="form.discount" :min="0" :precision="2" :step="1"></el-input-number>
          <span class="form-tip" style="margin-left:12px;">元</span>
        </el-form-item>
        <el-form-item v-if="!form.id" label="库存总数量" prop="totalStock">
          <el-input-number v-model="form.totalStock" :min="0" :step="10"></el-input-number>
          <span class="form-tip" style="margin-left:12px;">张</span>
        </el-form-item>
        <el-form-item label="生效时间" prop="startTime">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="留空表示立即生效"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="过期时间" prop="endTime">
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="留空表示永不过期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="255" show-word-limit placeholder="选填"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 发放统计对话框 -->
    <el-dialog
      :title="`发放统计 - ${statsData.couponName || ''}`"
      :visible.sync="statsDialogVisible"
      width="640px"
      @opened="renderStatsChart"
      @close="destroyStatsChart"
    >
      <div v-loading="statsLoading" class="stats-dialog">
        <div class="stats-summary">
          <div class="stats-item">
            <span class="stats-label">总量</span>
            <span class="stats-value">{{ statsData.totalStock || 0 }}</span>
          </div>
          <div class="stats-item">
            <span class="stats-label">剩余库存</span>
            <span class="stats-value stats-remain">{{ statsData.remainStock || 0 }}</span>
          </div>
          <div class="stats-item">
            <span class="stats-label">已发放</span>
            <span class="stats-value stats-issued">{{ statsData.issuedCount || 0 }}</span>
          </div>
          <div class="stats-item">
            <span class="stats-label">已领用</span>
            <span class="stats-value">{{ statsData.receivedCount || 0 }}</span>
          </div>
          <div class="stats-item stats-item-clickable" @click="openIssueUserList('used', '已使用')">
            <span class="stats-label">已使用</span>
            <span class="stats-value">{{ statsData.usedCount || 0 }}</span>
            <span class="stats-hint">点击查看</span>
          </div>
          <div class="stats-item">
            <span class="stats-label">已过期</span>
            <span class="stats-value">{{ statsData.expiredCount || 0 }}</span>
          </div>
        </div>
        <div ref="statsChart" class="stats-chart"></div>
        <div class="stats-tip">提示：点击饼图「已使用」可查看使用用户列表</div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="statsDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 发放用户列表 -->
    <el-dialog
      :title="`${issueUserTitle} - ${statsData.couponName || ''}`"
      :visible.sync="issueUserDialogVisible"
      width="780px"
      append-to-body
    >
      <el-table :data="issueUserList" v-loading="issueUserLoading" border stripe max-height="420">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="groupNickname" label="群昵称" min-width="120">
          <template slot-scope="scope">{{ scope.row.groupNickname || '-' }}</template>
        </el-table-column>
        <el-table-column prop="nickname" label="用户昵称" min-width="120">
          <template slot-scope="scope">{{ scope.row.nickname || scope.row.username || '-' }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="130">
          <template slot-scope="scope">{{ scope.row.phone || '-' }}</template>
        </el-table-column>
        <el-table-column prop="receiveTime" label="领取时间" width="170">
          <template slot-scope="scope">{{ formatDateTime(scope.row.receiveTime) }}</template>
        </el-table-column>
        <el-table-column prop="useTime" label="使用时间" width="170">
          <template slot-scope="scope">{{ formatDateTime(scope.row.useTime) }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="issueUserPagination.total > 0"
        @current-change="handleIssueUserPageChange"
        :current-page="issueUserPagination.pageNum"
        :page-size="issueUserPagination.pageSize"
        :total="issueUserPagination.total"
        layout="total, prev, pager, next"
        style="margin-top: 16px; text-align: right;"
      ></el-pagination>
      <div slot="footer">
        <el-button type="primary" @click="issueUserDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 补库存对话框 -->
    <el-dialog title="补库存" :visible.sync="restockDialogVisible" width="420px">
      <el-form :model="restockForm" ref="restockForm" label-width="100px">
        <el-form-item label="优惠券名称">
          <span class="restock-info">{{ restockForm.name }}</span>
        </el-form-item>
        <el-form-item label="当前剩余库存">
          <span class="restock-info restock-amount">{{ restockForm.remainStock }} / {{ restockForm.totalStock }}</span>
        </el-form-item>
        <el-form-item label="追加库存" prop="amount" :rules="[{ required: true, message: '请输入追加数量', trigger: 'blur' }]">
          <el-input-number v-model="restockForm.amount" :min="1" :step="10"></el-input-number>
          <span class="form-tip" style="margin-left:12px;">张</span>
        </el-form-item>
        <el-form-item label="补库后剩余">
          <span class="restock-info restock-result">{{ (restockForm.remainStock || 0) + (restockForm.amount || 0) }} 张</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="restockDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmRestock" :loading="restockLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getCouponList, addCoupon, updateCoupon, deleteCoupon, updateCouponStatus, restockCoupon, getCouponStats, getCouponIssueUsers, getUserList } from '@/api'

export default {
  name: 'CouponManagement',
  data() {
    return {
      tableData: [],
      tableLoading: false,
      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      userOptions: [],
      userLoading: false,
      statsDialogVisible: false,
      statsLoading: false,
      statsData: {},
      statsChart: null,
      issueUserDialogVisible: false,
      issueUserLoading: false,
      issueUserList: [],
      issueUserTitle: '',
      issueUserStatusType: 'used',
      issueUserPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      form: {
        id: null,
        name: '',
        issueTargetType: 'all',
        userId: null,
        threshold: 0,
        discount: null,
        totalStock: 100,
        startTime: null,
        endTime: null,
        status: 1,
        remark: ''
      },
      restockDialogVisible: false,
      restockForm: {
        id: null,
        name: '',
        totalStock: 0,
        remainStock: 0,
        amount: null
      },
      restockLoading: false,
      rules: {
        name: [{ required: true, message: '请输入优惠券名称', trigger: 'blur' }],
        issueTargetType: [{ required: true, message: '请选择发放对象', trigger: 'change' }],
        userId: [{
          validator: (rule, value, callback) => {
            if (this.form.issueTargetType === 'individual' && !value) {
              callback(new Error('请选择用户'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        threshold: [{ required: true, message: '请填写使用门槛', trigger: 'blur' }],
        discount: [{ required: true, message: '请填写满减金额', trigger: 'blur' }],
        totalStock: [{ required: true, message: '请填写库存数量', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadData()
  },
  beforeDestroy() {
    this.destroyStatsChart()
  },
  methods: {
    getIssuedCount(row) {
      const total = row.totalStock || 0
      const remain = row.remainStock || 0
      return Math.max(total - remain, 0)
    },

    async handleShowStats(row) {
      this.statsDialogVisible = true
      this.statsLoading = true
      this.statsData = {
        couponId: row.id,
        couponName: row.name,
        totalStock: row.totalStock || 0,
        remainStock: row.remainStock || 0,
        issuedCount: this.getIssuedCount(row)
      }
      try {
        const res = await getCouponStats(row.id)
        this.statsData = res.data || this.statsData
      } catch (e) {
        this.$message.error('加载统计数据失败')
      } finally {
        this.statsLoading = false
        this.$nextTick(() => this.renderStatsChart())
      }
    },

    renderStatsChart() {
      if (!this.statsDialogVisible || !this.$refs.statsChart) return
      this.destroyStatsChart()
      this.statsChart = echarts.init(this.$refs.statsChart)
      const chartData = (this.statsData.chartData || []).filter(item => item.value > 0)
      const fallbackData = chartData.length > 0 ? chartData : [{ name: '暂无数据', value: 1 }]
      this.statsChart.setOption({
        color: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C'],
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          bottom: 0,
          data: fallbackData.map(item => item.name)
        },
        series: [{
          type: 'pie',
          radius: ['42%', '68%'],
          center: ['50%', '45%'],
          avoidLabelOverlap: true,
          itemStyle: {
            borderRadius: 6,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            formatter: '{b}\n{c}'
          },
          data: fallbackData
        }]
      })
      this.statsChart.off('click')
      this.statsChart.on('click', (params) => {
        if (params.name === '已使用') {
          this.openIssueUserList('used', '已使用')
        }
      })
    },

    async openIssueUserList(statusType, title) {
      if (!this.statsData.couponId) return
      if (statusType === 'used' && !(this.statsData.usedCount > 0)) {
        this.$message.info('暂无已使用记录')
        return
      }
      this.issueUserStatusType = statusType
      this.issueUserTitle = title
      this.issueUserPagination.pageNum = 1
      this.issueUserDialogVisible = true
      await this.loadIssueUserList()
    },

    async loadIssueUserList() {
      if (!this.statsData.couponId) return
      this.issueUserLoading = true
      try {
        const res = await getCouponIssueUsers(this.statsData.couponId, {
          statusType: this.issueUserStatusType,
          pageNum: this.issueUserPagination.pageNum,
          pageSize: this.issueUserPagination.pageSize
        })
        this.issueUserList = res.data?.list || []
        this.issueUserPagination.total = res.data?.total || 0
      } catch (e) {
        this.$message.error('加载用户列表失败')
      } finally {
        this.issueUserLoading = false
      }
    },

    handleIssueUserPageChange(page) {
      this.issueUserPagination.pageNum = page
      this.loadIssueUserList()
    },

    formatDateTime(value) {
      if (!value) return '-'
      return String(value).replace('T', ' ').slice(0, 19)
    },

    destroyStatsChart() {
      if (this.statsChart) {
        this.statsChart.dispose()
        this.statsChart = null
      }
    },

    async loadData() {
      this.tableLoading = true
      try {
        const res = await getCouponList({
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        })
        this.tableData = res.data?.records || res.data || []
        this.pagination.total = res.data?.total || 0
      } catch (e) {
        this.$message.error('加载数据失败')
      } finally {
        this.tableLoading = false
      }
    },

    handlePageChange(page) {
      this.pagination.pageNum = page
      this.loadData()
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.loadData()
    },

    handleAdd() {
      this.dialogTitle = '新增优惠券'
      this.resetForm()
      this.userOptions = []
      this.dialogVisible = true
    },

    handleEdit(row) {
      this.dialogTitle = '编辑优惠券'
      this.form = {
        id: row.id,
        name: row.name,
        threshold: row.threshold || 0,
        discount: row.discount,
        startTime: row.startTime,
        endTime: row.endTime,
        status: row.status,
        remark: row.remark
      }
      this.dialogVisible = true
    },

    handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields()
      this.userOptions = []
      this.resetForm()
    },

    handleIssueTargetChange(value) {
      if (value !== 'individual') {
        this.form.userId = null
        this.userOptions = []
      } else if (this.form.totalStock > 1) {
        this.form.totalStock = 1
      }
    },

    formatUserLabel(user) {
      const parts = []
      if (user.groupNickname) {
        parts.push(`群昵称:${user.groupNickname}`)
      }
      if (user.phone) {
        parts.push(`手机:${user.phone}`)
      }
      const shelfCode = this.getUserShelfCode(user)
      if (shelfCode) {
        parts.push(`上架:${shelfCode}`)
      }
      if (parts.length === 0) {
        return user.nickname || user.username || '未知用户'
      }
      return parts.join(' | ')
    },

    getUserShelfCode(user) {
      const mailing = user.mailingShelfCode ? user.mailingShelfCode.split(',')[0].trim() : ''
      if (mailing) return mailing
      const crowdfunding = user.crowdfundingShelfCode ? user.crowdfundingShelfCode.split(',')[0].trim() : ''
      return crowdfunding
    },

    async searchUsers(query) {
      if (!query || query.trim().length < 1) {
        this.userOptions = []
        return
      }
      this.userLoading = true
      try {
        const res = await getUserList({
          pageNum: 1,
          pageSize: 20,
          status: 1,
          keyword: query.trim()
        })
        this.userOptions = res.data?.list || []
      } catch (e) {
        console.error(e)
      } finally {
        this.userLoading = false
      }
    },

    resetForm() {
      this.form = {
        id: null,
        name: '',
        issueTargetType: 'all',
        userId: null,
        threshold: 0,
        discount: null,
        totalStock: 100,
        startTime: null,
        endTime: null,
        status: 1,
        remark: ''
      }
    },

    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        try {
          const data = { ...this.form }
          if (data.threshold === 0) data.threshold = null
          if (this.form.id) {
            delete data.totalStock
            delete data.issueTargetType
            delete data.userId
            await updateCoupon(this.form.id, data)
            this.$message.success('更新成功')
          } else {
            if (data.issueTargetType !== 'individual') {
              delete data.userId
            }
            await addCoupon(data)
            this.$message.success(data.issueTargetType === 'individual' ? '新增并发放成功' : '新增成功')
          }
          this.dialogVisible = false
          this.loadData()
        } catch (e) {
          // 错误已在拦截器处理
        } finally {
          this.submitLoading = false
        }
      })
    },

    handleStatus(row) {
      const action = row.status === 1 ? '禁用' : '启用'
      this.$confirm(`确定要${action}「${row.name}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await updateCouponStatus(row.id, row.status === 1 ? 0 : 1)
          this.$message.success(`${action}成功`)
          this.loadData()
        } catch (e) {}
      }).catch(() => {})
    },

    handleRestock(row) {
      this.restockForm = {
        id: row.id,
        name: row.name,
        totalStock: row.totalStock,
        remainStock: row.remainStock,
        amount: null
      }
      this.restockDialogVisible = true
    },

    confirmRestock() {
      this.$refs.restockForm.validate(async (valid) => {
        if (!valid) return
        this.restockLoading = true
        try {
          await restockCoupon(this.restockForm.id, this.restockForm.amount)
          this.$message.success('补库存成功')
          this.restockDialogVisible = false
          this.loadData()
        } catch (e) {
          // 错误已在拦截器处理
        } finally {
          this.restockLoading = false
        }
      })
    },

    handleDelete(row) {
      this.$confirm(`确定要删除「${row.name}」吗？删除后不可恢复。`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteCoupon(row.id)
          this.$message.success('删除成功')
          this.loadData()
        } catch (e) {}
      }).catch(() => {})
    },

    formatDate(date) {
      if (!date) return '—'
      return date.substring(0, 16).replace('T', ' ')
    }
  }
}
</script>

<style scoped lang="scss">
.coupon-management {
  padding: 20px;
}

.form-tip {
  color: #909399;
  font-size: 12px;
}

.restock-info {
  color: #303133;
  line-height: 40px;
}

.restock-amount {
  color: #F56C6C;
  font-weight: bold;
}

.restock-result {
  color: #67C23A;
  font-weight: bold;
}

.stock-cell {
  cursor: pointer;
  line-height: 1.6;
}

.stock-line {
  font-size: 13px;
  color: #606266;
}

.stock-remain {
  color: #F56C6C;
  font-weight: 600;
}

.stock-issued {
  color: #409EFF;
}

.stock-link {
  font-size: 12px;
}

.stats-dialog {
  min-height: 360px;
}

.stats-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.stats-item {
  background: #f5f7fa;
  border-radius: 8px;
  padding: 12px;
  text-align: center;
}

.stats-label {
  display: block;
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}

.stats-value {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.stats-remain {
  color: #F56C6C;
}

.stats-issued {
  color: #409EFF;
}

.stats-item-clickable {
  cursor: pointer;
  transition: background-color 0.2s;
}

.stats-item-clickable:hover {
  background: #ecf5ff;
}

.stats-hint {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: #409EFF;
}

.stats-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  text-align: center;
}

.stats-chart {
  width: 100%;
  height: 320px;
}
</style>
